import { useState, useLayoutEffect } from 'react'
import debounce from 'lodash/debounce'

const useWindowSize = () => {
  const w = window.innerWidth
  const [size, setSize] = useState([w, 0])
  useLayoutEffect(() => {
    const updateSize = debounce(() => {
      setSize([window.innerWidth, window.innerHeight])
    }, 75)
    window.addEventListener('resize', updateSize)
    updateSize()
    return () => window.removeEventListener('resize', updateSize)
  }, [])
  return size
}

export default useWindowSize
